import { render, staticRenderFns } from "./DataTableLocal.vue?vue&type=template&id=0d0ed0c4&"
import script from "./DataTableLocal.vue?vue&type=script&lang=js&"
export * from "./DataTableLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports